import { resultDecisionSubjectTypeOptions } from 'KnmPmPackage/PmResultOfInspection/components/PmResultOfInspectionPmResultDecisions';
import { KnmResultDecisionSubjectTypesEnum } from 'KnmPackage/KnmSubjectModule/enums/KnmResultDecisionSubjectTypesEnum';

import { RenderFunc } from '../types/RenderFunc';

const formatSubjectTypeHistoryValue = (value: unknown) => {
  switch (value) {
    case 1:
      return (
        resultDecisionSubjectTypeOptions.find(
          item => item.value === KnmResultDecisionSubjectTypesEnum.CONTROLLING_SUBJECT,
        )?.label ?? ''
      );
    case 2:
      return (
        resultDecisionSubjectTypeOptions.find(item => item.value === KnmResultDecisionSubjectTypesEnum.FOUNDER)
          ?.label ?? ''
      );
    default: {
      if (typeof value === 'number' || typeof value === 'string') {
        return String(value);
      }

      return '';
    }
  }
};

export const renderPmResultDecisionSubjectType: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue: formatSubjectTypeHistoryValue(oldValue),
    renderedNewValue: formatSubjectTypeHistoryValue(newValue),
  };
};
